import React, { useState } from 'react';
import Button from 'jbc-front/components/Button';
import { Balloon } from 'jbc-front/components/presenters/ui/Balloon';
import styles from './AddHealthCheckupInstitution.scss';
import { useHistory } from 'react-router-dom';

export const AddHealthCheckupInstitution = () => {
  const [isBalloonOpen, setIsBalloonOpen] = useState(false);
  const history = useHistory();

  return (
    <>
      <Balloon.Container onClose={() => setIsBalloonOpen(false)}>
        <Button
          widthAuto
          className={styles.addHealthCheckupInstitutionButton}
          onClick={() => setIsBalloonOpen(isOpen => !isOpen)}
          primary>
          実施機関登録・更新
        </Button>
        <Balloon isOpen={isBalloonOpen}>
          <Balloon.Item onClick={() => history.push('/settings/health_checkup_institution/create')}>
            新規登録（直接入力）
          </Balloon.Item>
          <Balloon.Item onClick={() => history.push('/settings/import_health_checkup_institution')}>
            新規登録・更新（CSVインポート）
          </Balloon.Item>
        </Balloon>
      </Balloon.Container>
    </>
  );
};
